<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="write icon"></i>
      {{ $t("outbox template") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/outbox.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form">
          <div class="two fields">
            <div class="field">
              <label>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="setup.name" />
            </div>
            <div class="field">
              <label for="">{{ $t("outbox provider") }}</label>
              <div class="ui selection dropdown" ref="provider">
                <input type="hidden" name="ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("message") }}</label>
            <div class="ui two item top attached tabular menu" ref="tabs">
              <a class="active item" data-tab="content">
                <i class="write icon"></i> {{ $t("content") }}</a
              >
              <a class="item" data-tab="arguments">
                <i class="list icon"></i> {{ $t("arguments") }}</a
              >
            </div>
            <div
              class="ui bottom attached active tab segment"
              data-tab="content"
            >
              <div class="field">
                <label for="">{{ $t("title") }}</label>
                <input type="text" name="title" v-model="setup.title" />
              </div>
              <div class="ui info visible message">
                <h5 class="head">{{ $t("hints") }}</h5>
                <ul class="list">
                  <li
                    v-html="
                      $t('use ${variable_name} nomenclature for variables')
                    "
                  ></li>
                  <li
                    v-html="
                      $t('use shortio(http://..) to generate short.io url')
                    "
                  ></li>
                </ul>
              </div>
              <div class="field">
                <label for="">{{ $t("content") }}</label>
                <code-editor
                  v-model="setup.message"
                  type="html"
                  icon="html5"
                  theme="monokai"
                  ref="html_code_editor"
                  :title="$t('html code')"
                  :show_format="true"
                ></code-editor>
              </div>
            </div>
            <div class="ui bottom attached tab segment" data-tab="arguments">
              <h4 class="ui dividing header">{{ $t("arguments") }}</h4>
              <div
                class="field"
                v-for="(argument, i) in setup.arguments"
                :key="i"
              >
                <label for="">{{ argument.name }}</label>
                <input type="text" v-model="setup.arguments[i].default_value" />
              </div>
              <!-- <pre>{{ setup.arguments }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui red left floated icon right labeled button"
        @click="remove"
      >
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import CodeEditor from "@/components/code_editor/Index";
import { cloneDeep } from "lodash";

export default {
  name: "OutboxModalIndex",
  components: { CodeEditor },
  props: {
    branch_uuid: String,
  },
  computed: {},
  data() {
    return {
      setup: {
        name: "",
        provider: "",
        message: "",
        title: "",
        arguments: [],
      },
      uuid: "",
      providers: [],
    };
  },
  methods: {
    show_modal(uuid) {
      let vm = this;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            let vls = vm.providers.map((p) => {
              return { name: p.name, value: p.provider_id };
            });
            window
              .jQuery(vm.$refs.provider)
              .dropdown("setup menu", { values: vls })
              .dropdown({
                onChange(value) {
                  vm.setup.provider = value;
                },
              });

            window
              .jQuery(vm.$refs.tabs)
              .find(".item")
              .tab();

            if (uuid) {
              /**
               * Get info
               */

              local_api(vm, "post", "/outbox/template/do-get", {
                u: uuid,
              })
                .then((tpl) => {
                  vm.uuid = uuid;
                  let args = tpl.setup.arguments;
                  vm.setup = tpl.setup;

                  if (tpl.provider_id) {
                    window
                      .jQuery(vm.$refs.provider)
                      .dropdown("set selected", tpl.provider_id);
                  }

                  setTimeout(() => {
                    if (args) vm.setup.arguments = args;
                  }, 1000);
                })
                .catch((err) => {
                  error_toast(err);
                });
            }
          },
        })
        .modal("show");
      // vm.init(data.robocredit_application_uuid);
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove outbox template?"),
        function() {
          local_api(vm, "post", "/outbox/template/do-delete", {
            // u: vm.setup.robocredit_application_uuid,
          })
            .then(() => {
              window.jQuery(vm.$refs.modal).modal("hide");
              vm.$emit("deleted");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    save() {
      let vm = this;
      local_api(vm, "post", "/outbox/template/do-save", {
        u: vm.uuid,
        s: vm.setup,
      })
        .then(() => {
          window.jQuery(vm.$refs.modal).modal("hide");
          vm.$emit("success");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    calculate_tokens() {
      let vm = this;
      let argums = [];

      if (vm.setup.message) {
        let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
        let _args = vm.setup.message.match(regex);
        if (_args) {
          argums = argums.concat(
            _args.map((v) => {
              return { name: v, default_value: "" };
            }),
          );
        }
      }

      if (vm.setup.title) {
        let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
        let __args = vm.setup.title.match(regex);
        if (__args) {
          argums = argums.concat(
            __args.map((v) => {
              return { name: v, default_value: "" };
            }),
          );
        }
      }

      let args_ = [];
      for (let index = 0; index < argums.length; index++) {
        const __arg = argums[index];
        let trgt = args_.find((_arg) => {
          return _arg.name == __arg.name;
        });
        if (!trgt) {
          args_.push(__arg);
        }
      }

      vm.setup.arguments = cloneDeep(args_);
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/outbox/provider/do-get-list").then((providers) => {
      vm.providers = providers;
    });
  },
  watch: {
    "setup.message": function() {
      let vm = this;
      vm.calculate_tokens();
      // if (vm.setup.message) {
      //   let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
      //   let args = vm.setup.message.match(regex);
      //   vm.setup.arguments = args.map((v) => {
      //     return { name: v, default_value: "" };
      //   });
      // } else vm.setup.arguments = [];
    },
    "setup.title": function() {
      let vm = this;
      vm.calculate_tokens();
      // if (vm.setup.title) {
      //   let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
      //   let args = vm.setup.title.match(regex);
      //   vm.setup.arguments = args.map((v) => {
      //     return { name: v, default_value: "" };
      //   });
      // } else vm.setup.arguments = [];
    },
  },
  updated: function() {},
};
</script>
